import axios from '@/http/axios/index.js'

export default {
    list(payload) {
        return axios.get('expense/automatic/list', { params: payload })
    },
    getVendors(payload) {
        return axios.get('vendors-internal/list', { params: payload })
    },
    addVendor(payload) {
        return axios.post('expense/automatic', payload)
    },
    updateVendor(payload) {
        return axios.post('expense/automatic/update', payload)
    },
    search(payload) {
        return axios.get('expense/automatic/vendors', { params: payload })
    },
}
